import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

interface ITelemedApplicationPopupProps {
    telemedUrl: string;
    onClose: () => void;
}

class TelemedApplicationPopupState {
    public isFullScreen: boolean = false;
}

class TelemedApplicationPopup extends BaseReactComponent<ITelemedApplicationPopupProps, TelemedApplicationPopupState> {
    public constructor(props: ITelemedApplicationPopupProps) {
        super(props);
        this.state = new TelemedApplicationPopupState();
    }

    public componentDidMount(): void {
        this.setResizeableAndDraggable(true);
        window.addEventListener("message", this.telemedAppListener.bind(this));
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
        if (!this.state.isFullScreen)
            this.setResizeableAndDraggable(false);

        window.removeEventListener("message", this.telemedAppListener);
    }

    public render(): JSX.Element {
        return (
            <div
                id="telemedApplicationPopup"
                className={"popup telemed-popup " + (this.state.isFullScreen ? "fullscreen" : "")}
            >
                <div className="close-header">
                    <a className="close" aria-label="Close" onClick={() => this.props.onClose()}>×</a>
                </div>
                <div style={{ flex: "1 1 auto" }}>
                    <iframe
                        id="telemedIframe"
                        src={this.props.telemedUrl}
                        height="100%"
                        allow="camera *; microphone *"
                        width="100%"
                        frameBorder={0}
                    />
                </div>
                {!this.state.isFullScreen &&
                    <div style={{ width: "100%", height: "15px" }} />
                }
            </div>
        );
    }

    private setResizeableAndDraggable(enabled: boolean): void {
        const telemedApplicationPopup = $("#telemedApplicationPopup");
        if (!telemedApplicationPopup.length)
            return;

        if (enabled) {
            telemedApplicationPopup
                .resizable({ minWidth: 260, minHeight: 310, handles: "all", containment: "document" })
                .draggable({ containment: "window" });
        }
        else {
            telemedApplicationPopup.resizable("destroy");
            telemedApplicationPopup.draggable("destroy");
        }
    }

    private telemedAppListener(e: MessageEvent): void {
        switch (e.data) {
            case "hangUp":
                this.props.onClose();
                break;
            case "fullScreen":
                this.mutateState(
                    s => s.isFullScreen = !s.isFullScreen,
                    () => this.setResizeableAndDraggable(!this.state.isFullScreen)
                );
                break;
        }
    }
}

export { TelemedApplicationPopup };
